import { Directive, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { NgModel } from '@angular/forms';
import { parseTime } from '@mhe/ngx-shared/utils';
import * as i0 from "@angular/core";
import * as i1 from "@angular/forms";
export class TimeFormatDirective {
    constructor(ngModel) {
        this.ngModel = ngModel;
        this.timeParsed = new EventEmitter();
    }
    onBlur(event) {
        this.parseTime(event.target.value);
    }
    parseTime(value) {
        const parsed = parseTime(value, this.hourFormat);
        this.timeParsed.emit(parsed);
        if (!parsed.valid && parsed.timeDisplay !== '') {
            const errors = this.ngModel.errors;
            this.ngModel.control.setErrors(Object.assign(Object.assign({}, errors), { timeFormat: true }));
        }
    }
    clearInput() {
        this.parseTime('');
    }
}
TimeFormatDirective.ɵfac = function TimeFormatDirective_Factory(t) { return new (t || TimeFormatDirective)(i0.ɵɵdirectiveInject(i1.NgModel)); };
TimeFormatDirective.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: TimeFormatDirective, selectors: [["", "mheTimeFormat", ""]], hostBindings: function TimeFormatDirective_HostBindings(rf, ctx) { if (rf & 1) {
        i0.ɵɵlistener("blur", function TimeFormatDirective_blur_HostBindingHandler($event) { return ctx.onBlur($event); });
    } }, inputs: { hourFormat: "hourFormat" }, outputs: { timeParsed: "timeParsed" }, exportAs: ["mheTimeFormat"], features: [i0.ɵɵProvidersFeature([NgModel])] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TimeFormatDirective, [{
        type: Directive,
        args: [{
                selector: '[mheTimeFormat]',
                exportAs: 'mheTimeFormat',
                providers: [NgModel],
            }]
    }], function () { return [{ type: i1.NgModel }]; }, { hourFormat: [{
            type: Input
        }], timeParsed: [{
            type: Output
        }], onBlur: [{
            type: HostListener,
            args: ['blur', ['$event']]
        }] }); })();
